module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "30",
      "height": "30",
      "viewBox": "0 0 30 30",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.6216 1.62162C16.6216 0.726025 15.8956 0 15 0C14.1044 0 13.3784 0.726025 13.3784 1.62162V13.3784H1.62162C0.726025 13.3784 0 14.1044 0 15C0 15.8956 0.726025 16.6216 1.62162 16.6216H13.3784V28.3784C13.3784 29.274 14.1044 30 15 30C15.8956 30 16.6216 29.274 16.6216 28.3784V16.6216H28.3784C29.274 16.6216 30 15.8956 30 15C30 14.1044 29.274 13.3784 28.3784 13.3784H16.6216V1.62162Z",
      "fill": "black",
      "fill-opacity": "0.2"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-635829a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-635829a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/PlusImage.vue
// module id = 1504
// module chunks = 159